<template>
  <material-card
    style="margin-top: 30px"
    scrollable
    :title="$t('components.plancreationwizard.sick_payment_bank_eligibility')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="rule_folder"
  >
    <v-card-text>
      <v-form v-model="valid" :disabled="disabled">
        {{ $t("components.plancreationwizard.plan_entry_rules") }}
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-select
              v-model="eligibility.CreditHours"
              :items="creditTypes"
              :label="$t('components.plancreationwizard.credit_types')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="eligibility.CreditHours === true"
          >
            <no-autocomplete-textfield
              :value="eligibility.MaximumHours"
              @change="eligibility.MaximumHours = $event"
              :label="$t('components.plancreationwizard.maximum_hours')"
              class="required"
              :rules="[$rules.requiredInteger]"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-else-if="eligibility.CreditHours === false"
          >
            <no-autocomplete-textfield
              :value="eligibility.MaximumDays"
              @change="eligibility.MaximumHours = $event"
              :label="$t('components.plancreationwizard.maximum_days')"
              class="required"
              :rules="[$rules.requiredInteger]"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-select
              v-model="eligibility.CreditWithEmployerReports"
              :items="creditMethods"
              :label="$t('components.plancreationwizard.credit_methods')"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="eligibility.CreditWithEmployerReports === false"
          >
            <currency-textfield
              v-model="eligibility.FlatAmount"
              :label="$t('enums.FlatAmount')"
              class="required"
              :rules="[$rules.requiredNum]"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="eligibility.CreditHours === true"
          >
            <no-autocomplete-textfield
              :value="eligibility.HoursPerSickDay"
              @change="eligibility.HoursPerSickDay = $event"
              :label="$t('components.plancreationwizard.hours_per_sick_day')"
              class="required"
              :rules="[$rules.requiredInteger]"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :value="eligibility.MaximumDaysPerSickLeave"
              @change="eligibility.MaximumDaysPerSickLeave = $event"
              :label="
                $t('components.plancreationwizard.maximum_days_per_sick_leave')
              "
              class="required"
              :rules="[$rules.required, $rules.decimal]"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="eligibility.AllowHalfDaysPayment"
              :label="
                $t('components.plancreationwizard.allow_half_days_payment')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <currency-textfield
              v-model="eligibility.ReimbursementPerSickDay"
              :label="
                $t('components.plancreationwizard.reimbursement_per_sick_day')
              "
              class="required"
              :rules="[$rules.requiredNum]"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";
import { mapGetters } from "vuex";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";

export default {
  props: ["eligibility", "disabled"],
  components: {
    NoAutocompleteTextfield,
    CurrencyTextfield,
  },
  data() {
    return {
      valid: false,
      creditTypes: [
        {
          text: this.$t("enums.Hours"),
          value: true,
        },
        {
          text: this.$t("enums.Days"),
          value: false,
        },
      ],
      creditMethods: [
        {
          text: this.$t("enums.EmployerReports"),
          value: true,
        },
        {
          text: this.$t("enums.FlatAmount"),
          value: false,
        },
      ],
    };
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
  },
  methods: {},
};
</script>
